import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from "@reduxjs/toolkit/query/react";

export async function fetchActiveCategories(_args, _api, _options, baseQuery) {
  const categories = new Map();
  let page = 1;
  let pages = 1;
  do {
    const result = await baseQuery({ url: '/categories/active', params: { page, limit: 100 } });
    if (result.error) return { error: result.error };
    if (!Array.isArray(result.data?.data)) {
      return { error: { status: 'CUSTOM_ERROR', error: 'Kategorierna kunde inte läsas.' } };
    }
    result.data.data.forEach(category => {
      if (category?._id) categories.set(category._id, category);
    });
    const reportedPages = Number(result.data.pagination?.pages || 1);
    if (!Number.isSafeInteger(reportedPages) || reportedPages < 1 || reportedPages > 1000) {
      return { error: { status: 'CUSTOM_ERROR', error: 'Kategoriernas sidindelning kunde inte läsas.' } };
    }
    pages = reportedPages;
    page += 1;
  } while (page <= pages);
  return { data: { success: true, data: [...categories.values()] } };
}

export const categoryApiService = createApi({
  reducerPath: "categoryApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${baseURL}` }), // Base URL for your API
  endpoints: (builder) => ({
    getAllCategoriesWithSubcategories: builder.query({
      queryFn: fetchActiveCategories,
      // Every consumer requests the same complete list, regardless of legacy arguments.
      serializeQueryArgs: ({ endpointName }) => endpointName,
      keepUnusedDataFor: 60,
    }),
    getHomeCategories: builder.query({
      query: () => '/categories/home',
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useGetAllCategoriesWithSubcategoriesQuery, useGetHomeCategoriesQuery } = categoryApiService;
